import { useEffect, useState, useRef } from 'react'
import Modal from '@components/Modal'
import CircleLoader from '@components/CircleLoader'
import ErrorMessage from '@components/ErrorMessage'

import { getTermsAndConditions } from 'subscription-flow/canada/actions'
import {
    termsAndConditionsSelector,
    termsConditionsLoadingSelector,
    termsConditionsErrorSelector,
} from 'subscription-flow/canada/selectors'
import isMobile from 'shared/responsive-helpers'

const TermsAndConditions = ({
    getTermsAndConditions,
    closeModal,
    termsConditions,
    loading,
    error,
    onAcceptTermsHandler,
    termsAcceptedDate,
}) => {
    const [isButtonEnabled, setButtonEnabled] = useState(false)

    useEffect(() => {
        getTermsAndConditions()
    }, [])

    const scrollContainerRef = useRef(null)

    const handleScroll = () => {
        const { scrollTop, scrollHeight, clientHeight } = scrollContainerRef.current
        const isNearBottom = scrollTop + clientHeight >= scrollHeight * 0.99

        if (isNearBottom) {
            setButtonEnabled(true)
        }
    }

    return (
        <Modal
            outsideClickDisabled={false}
            onClose={closeModal}
            className={'modal--sticky-footer'}
            header={termsConditions?.title}
            contentRef={scrollContainerRef}
            onScroll={handleScroll}
            buttons={
                termsAcceptedDate == null && [
                    {
                        label: <T>subscription.purchase.modal.label.cancel</T>,
                        btnStyle: 'outline',
                        disabled: !isButtonEnabled,
                        onClick: () => closeModal(),
                    },
                    {
                        label: <T>subscription.purchase.modal.label.accept</T>,
                        size: 'small',
                        btnStyle: 'primary',
                        disabled: !isButtonEnabled,
                        onClick: () => {
                            onAcceptTermsHandler()
                        },
                    },
                ]
            }
            size={isMobile() ? 'small' : 'large'}>
            {!loading && error && <ErrorMessage className="mt-2" messages={[error]} />}
            {loading && !error ? (
                <CircleLoader className="m-auto" />
            ) : (
                <div
                    dangerouslySetInnerHTML={{
                        __html: termsConditions?.content,
                    }}
                />
            )}
        </Modal>
    )
}

export default compose(
    withTranslate,
    connect(
        createStructuredSelector({
            termsConditions: termsAndConditionsSelector,
            loading: termsConditionsLoadingSelector,
            error: termsConditionsErrorSelector,
        }),
        {
            getTermsAndConditions,
        }
    )
)(TermsAndConditions)
